var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineLazyReducers } from './combine-lazy-reducers';
export var injectAsyncReducer = function (_a) {
    var store = _a.store, name = _a.name, reducer = _a.reducer, isRoot = _a.isRoot;
    var asyncReducers = store.asyncReducers;
    var rootReducers = store.rootReducers;
    var initialState = __assign(__assign({}, store.initialState), store.getState());
    var wasAsyncReducerInjected = Boolean(asyncReducers[name]);
    var wasRootReducerInjected = Boolean(rootReducers[name]);
    if (wasAsyncReducerInjected || wasRootReducerInjected) {
        if (wasAsyncReducerInjected) {
            if (process.env.REACT_APP_REDUX_DEBUG) {
                // eslint-disable-next-line
                console.warn(name + " reducer was injected earlier");
            }
        }
        if (wasRootReducerInjected) {
            // eslint-disable-next-line
            console.warn(name + " reducer was injected in the root reducer earlier");
        }
        return;
    }
    if (isRoot) {
        // register root reducer to the store
        rootReducers[name] = reducer;
    }
    else {
        // register reducer to the store
        asyncReducers[name] = reducer;
    }
    // define new reducers
    var newReducer = combineLazyReducers(__assign(__assign({}, asyncReducers), rootReducers), initialState);
    // log to the devtools
    store.dispatch({
        type: '@REDUX-CORE-MODULES INJECT REDUCER',
        payload: {
            name: name,
        },
    });
    // inject reducer
    store.replaceReducer(newReducer);
};
